/**
 * Redux Persist Storage Adapter
 * 
 * Adapts redux-persist/lib/storage to our IPersistStorage interface
 */

import storage from 'redux-persist/lib/storage';
import type { IPersistStorage } from '../types';

/**
 * Adapter for redux-persist storage
 */
export const reduxPersistStorageAdapter: IPersistStorage = {
  getItem: (key: string) => {
    return storage.getItem(key);
  },
  setItem: (key: string, value: string) => {
    return storage.setItem(key, value);
  },
  removeItem: (key: string) => {
    return storage.removeItem(key);
  },
};
